module.exports = __webpack_public_path__ + "img/farming_49.52ca8737.png";